export const PAYMENT_METHODS = ['card', 'ach', 'cash', 'check'];
export const PAYMENT_METHOD_LABELS = {
    card: 'Card',
    ach: 'ACH',
    cash: 'Cash',
    check: 'Check',
};
export const ORDER_STATUSES = ['pending', 'completed', 'failed', 'refunded', 'partially_refunded'];
export const EVENT_STATUSES = ['draft', 'published', 'cancelled'];
export const USER_ROLES = ['user', 'admin'];
export const ACCOUNT_TYPES = ['asset', 'liability', 'equity', 'income', 'expense'];
export const ACCOUNT_SUBTYPES = [
    'bank',
    'undeposited_funds',
    'accounts_payable',
    'credit_card',
    'opening_balance_equity',
    'merchant_fees',
    'discounts',
    'bank_fees',
    'interest_income',
    'other',
];
export const PAYMENT_TERMS = ['Due On Receipt', 'Net 15', 'Net 30', 'COD'];
export const BILL_STATUSES = ['unpaid', 'partial', 'paid', 'void'];
export const CHECK_STATUSES = ['to_print', 'printed', 'handwritten', 'void'];
export const DEPOSIT_STATUSES = ['open', 'deposited', 'void'];
export const JOURNAL_SOURCE_TYPES = [
    'sale',
    'refund',
    'receipt',
    'deposit',
    'deposit_reversal',
    'bill',
    'bill_void',
    'bill_payment',
    'payment_void',
    'card_charge',
    'card_payment',
    'manual',
    'transfer',
    'opening_balance',
    'recon_adjustment',
    'import',
];
export const FILE_KINDS = [
    'event_image',
    'venue_logo',
    'site_hero',
    'bill_attachment',
    'check_signature',
    'check_font',
    'check_template',
    'check_pdf',
];
/** Which upload kinds anyone may read. Everything else is admin-only. */
export const PUBLIC_FILE_KINDS = ['event_image', 'venue_logo', 'site_hero'];
//# sourceMappingURL=enums.js.map